<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <div
        id="success-overlay"
        class="modal modal-lg modal-success"
        v-bind:class="{
          'is-active': statmentModal,
        }"
      >
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn">
          <div class="flex-card simple-shadow">
            <header class="modal-card-head">
              <p class="modal-card-title p-20">
                <b>كشف معاملات البطاقة</b>
              </p>
            </header>
            <div class="card-body">
              <div class="content">
                <section class="modal-card-body">
                  <div class="animated preFadeInUp fadeInUp">
                    <div>
                      <table
                        v-if="cardStatment != null && cardStatment.length > 0"
                        class="table is-striped mb-40"
                        border="solid"
                        cellpadding="10"
                      >
                        <thead>
                          <tr>
                            <th>تاريخ الحركة</th>
                            <th>القيمة</th>
                            <th>بيان الحركة</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(statement, index) in cardStatment
                              .slice()
                              .reverse()"
                            :key="index"
                          >
                            <td>{{ statement.transactionDate }}</td>
                            <td>{{ statement.amount }}</td>
                            <td>{{ statement.description }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else>
                        لم يتم العثور علي اي معاملات لهذة البطاقة
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="mt-20">
                <a
                  class="button danger-btn btn-align modal-dismiss is-bold is-medium"
                  style="margin: 10px"
                  @click="statmentModalClose"
                >
                  <b>إغلاق</b>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="modal-close is-large"></button> -->
      </div>

      <div
        id="success-overlay"
        class="modal modal-lg modal-success"
        v-bind:class="{
          'is-active': resetCardModal,
        }"
      >
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn">
          <div class="flex-card simple-shadow">
            <header class="modal-card-head">
              <p class="modal-card-title p-20">
                <b>رقم سري جديد</b>
              </p>
            </header>
            <div class="card-body">
              <div class="content">
                <section class="modal-card-body">
                  <div class="animated preFadeInUp fadeInUp">
                    <div>
                      <form @submit.prevent="validateBeforeSubmit">
                        <div class="field">
                          <div class="control">
                            <input
                              disabled
                              v-show="false"
                              v-model="resetPindata.cardId"
                              name="cardId"
                              class="input has-text-centered has-text-black is-medium is-centered is-english"
                              type="text"
                              placeholder=""
                              v-validate="'required'"
                              :class="{
                                input: true,
                                'is-danger': errors.has('cardId') || message,
                              }"
                            />
                            <span
                              v-show="errors.has('cardId')"
                              class="help is-danger is-centered"
                              >{{ errors.first("cardId") }}</span
                            >
                          </div>
                        </div>
                        <div class="field">
                          <div class="control">
                            <label class="label is-medium">
                              الرجاء ادخال رقم البطاقة
                            </label>
                            <input
                              v-model="resetPindata.cardNumber"
                              name="cardNumber"
                              class="input has-text-centered has-text-black is-success is-medium is-centered is-english"
                              type="text"
                              placeholder="رقم البطاقة"
                              v-validate="'required'"
                              :class="{
                                input: true,
                                'is-danger':
                                  errors.has('cardNumber') || message,
                              }"
                            />
                            <span
                              v-show="errors.has('cardNumber')"
                              class="help is-danger is-centered"
                              >{{ errors.first("cardNumber") }}</span
                            >
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </section>
              </div>
              <div class="mt-20">
                <a
                  class="button success-btn btn-align modal-dismiss is-bold is-medium"
                  style="margin: 10px"
                  @click="validateBeforeSubmitResetPin()"
                >
                  <b>موافق</b>
                </a>
                <a
                  class="button danger-btn btn-align modal-dismiss is-bold is-medium"
                  style="margin: 10px"
                  @click="resetCardModalClose"
                >
                  <b>إغلاق</b>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div
        id="success-overlay"
        class="modal modal-lg modal-success"
        v-bind:class="{
          'is-active': stopCardModal,
        }"
      >
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn">
          <div class="flex-card simple-shadow">
            <header class="modal-card-head">
              <p class="modal-card-title p-20">
                <b>إيقاف البطاقة</b>
              </p>
            </header>
            <div class="card-body">
              <div class="content">
                <section class="modal-card-body">
                  <div class="animated preFadeInUp fadeInUp">
                    <div>
                      <form @submit.prevent="changeCardStatus">
                        <div class="field">
                          <div class="control">
                            <label class="label"
                              >من فضلك إختر حالة البطاقة لإيقافها :
                            </label>
                            <div class="radio-option">
                              <b-radio
                                v-model="stopCardObject.status"
                                :class="{
                                  input: true,
                                  'is-danger': errors.has('status') || message,
                                }"
                                name="status"
                                native-value="restrict"
                              >
                                إيقاف البطاقة فقط (سيتم إيقاف هذه البطاقة،
                                وإلعادة تفعيلها ينبغي زيارة فرعك)
                              </b-radio>
                            </div>
                            <div class="radio-option">
                              <b-radio
                                v-model="stopCardObject.status"
                                :class="{
                                  input: true,
                                  'is-danger': errors.has('status') || message,
                                }"
                                name="status"
                                native-value="stolen"
                              >
                                إيقاف البطاقة واإلبالغ عن ضياعها (سيتم إيقاف هذه
                                البطاقة نهائياً واستخراج بطاقة بديلة)
                              </b-radio>
                            </div>
                            <div class="radio-option">
                              <b-radio
                                v-model="stopCardObject.status"
                                :class="{
                                  input: true,
                                  'is-danger': errors.has('status') || message,
                                }"
                                name="status"
                                native-value="lost"
                                >إيقاف البطاقة واإلبالغ عن سرقتها (سيتم إيقاف
                                هذه البطاقة نهائياً واستخراج بطاقة بديلة)
                              </b-radio>
                            </div>

                            <span
                              v-show="errors.has('status')"
                              class="help is-danger is-centered"
                              >{{ errors.first("status") }}</span
                            >
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </section>
              </div>
              <div class="mt-20">
                <a
                  class="button success-btn btn-align modal-dismiss is-bold is-medium"
                  style="margin: 10px"
                  @click="stopCard()"
                >
                  <b>موافق</b>
                </a>
                <a
                  class="button danger-btn btn-align modal-dismiss is-bold is-medium"
                  style="margin: 10px"
                  @click="stopCardModalClose"
                >
                  <b>إغلاق</b>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="content-wrapper animated preFadeInUp fadeInUp">
        <div class="section-title-wrapper has-text-centered mb-20">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-credit-card"> </i>
          </div>
          <div>
            <h2
              class="clean-section-title has-text-white has-text-weight-bold is-paddingless"
            >
              خدمات البطاقات الدولية (فيزا , ماستر كارد)
            </h2>
            <h3
              class="subtitle is-5 pt-10 pb-10 has-text-white has-text-weight-bold"
            ></h3>
          </div>
        </div>
        <h2></h2>
        <div class="container">
          <!-- <div class="columns is-centered">
          <!-- <div class="columns is-centered">
            <div class="column is-12">
              <button
                class="button is-info is-medium is-shadowless raised has-text-weight-bold is-pulled-right"
                style="background-color: #767171; border-color: black"
                @click="getNewCard()"
              >
                طلب بطاقة جديدة
              </button>
            </div>
          </div> -->
          <div
            class="columns has-text-centered is-centered"
            v-if="cardsAreLoading"
          >
            <loading
              line-fg-color="var(--primary-color)"
              size="large"
              class="margin-100"
              text-fg-color="#ffffff"
              message="الرجاء الإنتظار"
            />
          </div>
          <div
            class="columns is-multiline"
            v-else-if="customerCards != null && customerCards.length >= 1"
          >
            <div
              v-for="card in customerCards"
              :key="card.card_uid"
              class="column is-4"
            >
              <div
                class="flex-card icon-card-hover classTest visa-card light-bordered padding-20"
                style="
                  height: 270px;
                  padding: 20px 10px 10px 20px;
                  background-position: 0 0, -80px 110px;
                  border-radius: 2px;
                  box-shadow: 8px 8px 11px -3px rgba(0, 0, 0, 0.75);
                "
              >
                <hr
                  class="custom-hr"
                  style="
                    height: 12px;
                    margin: 0;
                    border-width: 6px;
                    background: linear-gradient(
                      30deg,
                      #c41230 70%,
                      #012169 30%
                    );
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                  "
                />
                <!-- Updated hr class -->
                <h6
                  class="card-title has-text-dark"
                  style="
                    display: flex;
                    justify-content: space-between;
                    direction: rtl;
                    font-weight: bold;
                  "
                >
                  <span>{{ card.title_ar }}</span>
                  <!-- English text -->
                  <span>{{ card.title_en }}</span>
                  <!-- Arabic text -->
                </h6>
                <hr
                  style="
                    margin-top: 0.5rem;
                    border-width: 2px;
                    border-color: #d1d1d1;
                  "
                />
                <div>
                  <span class="card-description"> رقم البطاقة : </span>
                  <span class="card-description">
                    {{ fixText(card.card_number) }}
                  </span>
                </div>
                <div>
                  <span class="card-description"> حالة البطاقة : </span>
                  <span class="card-description">
                    {{ card.card_status }}
                  </span>
                  <span
                    v-if="card.card_status.trim() === 'مفعلة'"
                    style="
                      color: var(--secondary-color);
                      text-decoration: underline;
                      font-size: 16px;
                      cursor: pointer;
                    "
                    @click="
                      changeCardStatusDialog(card, 'restrict', 'ايقاف التفعيل؟')
                    "
                    class="link"
                    >إيقاف تفعيل؟</span
                  >
                  <span
                    v-if="card.card_status.trim() === 'موقوفة'"
                    style="
                      color: var(--secondary-color);
                      text-decoration: underline;
                      font-size: 16px;
                      cursor: pointer;
                    "
                    class="link"
                    @click="
                      changeCardStatusDialog(card, 'open', 'إعادة تفعيل؟')
                    "
                    >إعادة تفعيل؟</span
                  >
                </div>
                <div>
                  <span class="card-description"> صالحة إلى : </span>
                  <span class="card-description">{{
                    fixDate(card.valid_until)
                  }}</span>
                </div>
                <div style="display: flex; gap: 10px; align-items: center">
                  <button
                    class="link card-description"
                    style="
                      color: var(--secondary-color);
                      text-decoration: underline;
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    "
                    @click="getCardBalance(card.card_uid)"
                  >
                    إظهار الرصيد :
                  </button>
                  <span v-if="cardBalanceLoading"
                    ><loading size="small"></loading
                  ></span>
                  <span
                    class="card-description"
                    v-else-if="cardBalances[card.card_uid] != null"
                  >
                    {{ cardBalances[card.card_uid] }}
                  </span>
                </div>
                <div
                  class="button-group"
                  style="margin-top: 15px; display: flex"
                >
                  <span
                    class="button is-success btn-align modal-dismiss is-bold is-small"
                    style="
                      margin-right: 10px;
                      background-color: #e9e9e9;
                      border-color: #f5cbcb;
                      color: #7e7e7e;
                      border-radius: 15px;
                      padding: 15px;
                    "
                    @click="getCardStatmentRequest(card.card_uid)"
                  >
                    <b>كشف المعاملات</b>
                  </span>
                  <!-- <span
                    class="button is-success btn-align modal-dismiss is-bold is-small"
                    style="
                      margin-right: 10px;
                      background-color: #e9e9e9;
                      border-color: #f5cbcb;
                      color: #7e7e7e;
                      border-radius: 15px;
                      padding: 15px;
                    "
                    @click="resetPinRequest(card.card_uid)"
                  >
                    <b>رقم سري جديد</b>
                  </span> -->
                </div>
              </div>
            </div>
          </div>
          <h2
            v-else-if="customerCards != null && customerCards.length == 0"
            class="hero-foot has-text-white has-text-weight-bold has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            لا يوجد لديك بطاقة
          </h2>
        </div>
        <!-- </div> -->
      </div>
      <!-- <div
        class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
      >
        <span class="has-text-white has-text-weight-bold is-pulled-right"
          >لم تظهر جميع بياناتي</span
        >
        <button
          class="button is-info is-medium is-shadowless raised has-text-weight-bold is-pulled-right"
          style="
            background-color: #767171;
            border-color: black;
            margin-right: 15px;
          "
          @click="refreshCards()"
        >
          تحديث البيانات
        </button>
      </div> -->
      <br />
      <div
        class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
      >
        <a
          class="button is-dark btn-align modal-dismiss is-bold is-medium"
          @click="$router.go('-1')"
        >
          <b>عودة للرئيسية</b>
        </a>
      </div>
    </div>
  </section>
</template>
<style>
.link {
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
  color: #012169 !important;
  font-weight: bold;
}
.custom-hr {
  height: 6px; /* Adjust thickness as needed */
  background: linear-gradient(
    30deg,
    #c41230 70%,
    #012169 30%
  ); /* Gradient from red to blue */
  border: none; /* Remove border */
  margin: 10px 0; /* Adjust margin as needed */
}
</style>
<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  name: "visa",

  data() {
    return {
      cardBalanceLoading: false,
      cardsAreLoading: false,
      customerdate: null,
      customertime: null,
      url: "vs/newRequest",
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: 1,
        BranchId: null,
      },
      customerCards: null,
      customerCardsFees: null,
      new_cardFees: null,
      card_statementFees: null,
      reset_pinFees: null,
      restrict_onlyFees: null,
      restrict_stolenFees: null,
      restrict_lostFees: null,
      cardBalance: null,
      resetPinMsg: null,
      cardStatment: null,
      statmentModal: false,
      resetCardModal: false,
      resetPindata: {
        cardId: null,
        cardNumber: null,
      },
      cardBalances: {},
      stopCardModal: false,
      newCardMsg: null,
      selectedOption: null,
      message: "",
      stopCardObject: {
        card_uid: null,
        status: null,
      },
      stopCardErrorMsg: null,
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.logItIn();
          return;
        }
      });
    },
    makeRequest(actionstring, action, url) {
      this.$router.push({
        name: "servicerequest",
        params: {
          requeststring: actionstring,
          requestid: action,
          requesturl: this.url,
        },
      });
    },
    fixText(text) {
      // Split the text into two parts based on the index
      // const starIndex = text.indexOf('*');
      // // Split the text into two parts based on the index of the first star
      // const firstPart = text.substring(0, starIndex);
      // const secondPart = text.substring(starIndex + 6); // Assuming there are always 6 stars
      // const middlePart = text.substring(starIndex, starIndex + 6); // The stars and the numbers in between
      // // Rearrange the parts and return the fixed text
      // return secondPart + middlePart + firstPart;
      const starIndex = text.indexOf("*");
      // Find the index of the last star
      const lastStarIndex = text.lastIndexOf("*");
      // Calculate the number of characters between the stars
      const middlePartLength = lastStarIndex - starIndex - 1;
      // Split the text into three parts based on the positions of the stars
      const firstPart = text.substring(0, starIndex);
      const middlePart = text.substring(starIndex, lastStarIndex + 1);
      const lastPart = text.substring(lastStarIndex + 1);
      // Rearrange the parts and return the fixed text
      return lastPart + middlePart + firstPart;
    },
    fixDate(dateStr) {
      // Parse the date string into a Date object
      const dateObj = new Date(dateStr);
      // Extract the day, month, and year from the Date object
      const day = dateObj.getDate();
      const month = dateObj.getMonth() + 1; // Months are zero-indexed, so we add 1
      const year = dateObj.getFullYear();
      // Rearrange the parts and return the fixed date
      return `${day}-${month < 10 ? "0" : ""}${month}-${year}`;
    },
    customerCardsFeesList() {
      this.new_cardFees = this.customerCardsFees.find(
        (service) => service.service_name === "new_card"
      );
      this.card_statementFees = this.customerCardsFees.find(
        (service) => service.service_name === "card_statement"
      );
      this.reset_pinFees = this.customerCardsFees.find(
        (service) => service.service_name === "reset_pin"
      );
      this.restrict_onlyFees = this.customerCardsFees.find(
        (service) => service.service_name === "restrict_only"
      );
      this.restrict_stolenFees = this.customerCardsFees.find(
        (service) => service.service_name === "restrict_stolen"
      );
      this.restrict_lostFees = this.customerCardsFees.find(
        (service) => service.service_name === "restrict_lost"
      );
    },
    getCustomerCards() {
      var user = JSON.parse(localStorage.getItem("user"));
      axios
        .get("/vs/cards/" + user[1])
        .then((response) => {
          // eslint-disable-next-line no-empty
          if (response.data.status === "success") {
            this.cardsAreLoading = false;
            this.customerCards = response.data.data;
            this.customerCardsFees = response.data.fees;
            //alert(response.data.fees)
            // console.log(response.data.fees)
            // console.log(this.customerCardsFees)
            this.customerCardsFeesList();
          } else if (response.data.status === "fail") {
            this.cardsAreLoading = false;
            // console.log("error");
          }
        })
        .catch((error) => {
          this.cardsAreLoading = false;
          this.$dialog.alert({
            message: "فشلت عملية الاتصال بالخدمة",
            confirmText: "عودة",
            size: "is-large",
            type: "is-danger",
            onConfirm: () => this.$router.push("/"),
          });
          console.log(error);
          this.$toasted.show(`${error.response.data.message}`, {
            theme: "outline",
            position: "top-center",
            duration: 3000,
            type: "error",
            theme: "bubble",
            className: "toasti",
            iconPack: "fontawesome",
            closeOnSwipe: true,
            icon: {
              name: "fa-times",
              before: true, // this will append the icon to the end of content
            },
          });
        });
    },
    refreshCards() {
      this.customerCards = null;
      this.cardsAreLoading = true;
      this.getCustomerCards();
    },
    getCardBalance(card_uid) {
      this.cardBalanceLoading = true;
      axios
        .get("/vs/card/balance/" + card_uid)
        .then((response) => {
          // eslint-disable-next-line no-empty
          this.cardBalanceLoading = false;
          if (response.data.status === "success") {
            this.cardBalance = response.data.balance;

            this.$set(this.cardBalances, card_uid, response.data.balance);
          } else if (response.data.status === "fail") {
            console.log("error");
          }
        })
        .catch((error) => {
          this.cardBalanceLoading = false;
          this.isLoading = !this.isLoading;
          console.log(error);
          this.$toasted.show(`${error.response.data.message}`, {
            theme: "outline",
            position: "top-center",
            duration: 3000,
            type: "error",
            theme: "bubble",
            className: "toasti",
            iconPack: "fontawesome",
            closeOnSwipe: true,
            icon: {
              name: "fa-times",
              before: true, // this will append the icon to the end of content
            },
          });
        });
    },
    resetPinRequest(card_uid) {
      if (this.reset_pinFees != null && this.reset_pinFees.has_fee == "false") {
        this.resetCardModalOpen(card_uid);
      } else if (
        this.reset_pinFees != null &&
        this.reset_pinFees.has_fee == "true"
      ) {
        this.resetPinDialog(
          this.new_cardFees.fee,
          this.new_cardFees.currency,
          card_uid
        );
      }
    },
    resetPin() {
      axios
        .post("/vs/card/resetpin", this.resetPindata)
        .then((response) => {
          // eslint-disable-next-line no-empty
          if (response.data.status === "success") {
            this.resetCardModal = false;
            this.resetPindata.cardId = null;
            this.resetPindata.cardNumber = null;
            this.resetPinMsg = response.data.message;
            this.resetPinMsgModal(response.data.message);
          } else if (response.data.status === "fail") {
            console.log("error");
          }
        })
        .catch((error) => {
          this.isLoading = !this.isLoading;
          console.log(error);
          this.$toasted.show(`${error.response.data.message}`, {
            theme: "outline",
            position: "top-center",
            duration: 3000,
            type: "error",
            theme: "bubble",
            className: "toasti",
            iconPack: "fontawesome",
            closeOnSwipe: true,
            icon: {
              name: "fa-times",
              before: true, // this will append the icon to the end of content
            },
          });
        });
    },
    getCardStatmentRequest(card_uid) {
      if (
        this.card_statementFees != null &&
        this.card_statementFees.has_fee == "false"
      ) {
        this.getCardStatment(card_uid);
      } else if (
        this.card_statementFees != null &&
        this.card_statementFees.has_fee == "true"
      ) {
        this.getCardStatmentDialog(
          this.card_statementFees.fee,
          this.card_statementFees.currency,
          card_uid
        );
      }
    },
    getCardStatment(card_uid) {
      this.cardsAreLoading = true;
      axios
        .get("/vs/card/statement/" + card_uid)
        .then((response) => {
          // eslint-disable-next-line no-empty
          this.cardsAreLoading = false;
          if (response.data.status === "success") {
            this.cardStatment = response.data.data;
            this.statmentModal = true;
          } else if (response.data.status === "fail") {
            console.log("error");
          }
        })
        .catch((error) => {
          this.cardsAreLoading = false;
          this.isLoading = !this.isLoading;
          console.log(error);
          this.$toasted.show(`${error.response.data.message}`, {
            theme: "outline",
            position: "top-center",
            duration: 3000,
            type: "error",
            theme: "bubble",
            className: "toasti",
            iconPack: "fontawesome",
            closeOnSwipe: true,
            icon: {
              name: "fa-times",
              before: true, // this will append the icon to the end of content
            },
          });
        });
    },
    statmentModalClose() {
      this.statmentModal = false;
    },
    stopCardModalOpen(cardUid) {
      this.stopCardObject.card_uid = cardUid;
      this.stopCardModal = true;
    },
    stopCardModalClose() {
      this.stopCardModal = false;
    },
    resetCardModalClose() {
      this.resetCardModal = false;
    },
    resetCardModalOpen(cardId) {
      this.resetPindata.cardId = cardId;
      this.resetCardModal = true;
    },
    validateBeforeSubmitResetPin() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.resetPin();
          return;
        }
      });
    },
    getNewCard() {
      if (this.new_cardFees != null && this.new_cardFees.has_fee == "false") {
        this.getNewCardRequest();
      } else if (
        this.new_cardFees != null &&
        this.new_cardFees.has_fee == "true"
      ) {
        this.newCardFeeDialog(
          this.new_cardFees.fee,
          this.new_cardFees.currency
        );
      }
    },

    getNewCardRequest() {
      var user = JSON.parse(localStorage.getItem("user"));
      axios
        .get("/vs/card/new/" + user[1])
        .then((response) => {
          // eslint-disable-next-line no-empty
          if (response.data.status === "success") {
            this.newCardMsg = response.data.message;
            this.newCardMsgModal(response.data.message);
          } else if (response.data.status === "fail") {
            console.log("error");
          }
        })
        .catch((error) => {
          this.isLoading = !this.isLoading;
          console.log(error);
          this.$toasted.show(`${error.response.data.message}`, {
            theme: "outline",
            position: "top-center",
            duration: 3000,
            type: "error",
            theme: "bubble",
            className: "toasti",
            iconPack: "fontawesome",
            closeOnSwipe: true,
            icon: {
              name: "fa-times",
              before: true, // this will append the icon to the end of content
            },
          });
        });
    },
    // validateBeforeSubmitStopCard() {
    //   this.$validator.validateAll().then((result) => {
    //     if (result) {
    //       this.changeCardStatus();
    //       return;
    //     }
    //   });
    // },
    // stopCard() {
    //   if (this.stopCardObject.status == "restrict") {
    //     if (
    //       this.restrict_onlyFees != null &&
    //       this.restrict_onlyFees.has_fee == "false"
    //     ) {
    //       this.changeCardStatus();
    //     } else if (
    //       this.restrict_onlyFees != null &&
    //       this.restrict_onlyFees.has_fee == "true"
    //     ) {
    //       this.stopCardDialog(
    //         this.restrict_onlyFees.fee,
    //         this.restrict_onlyFees.currency
    //       );
    //     }
    //   } else if (this.stopCardObject.status == "stolen") {
    //     if (
    //       this.restrict_stolenFees != null &&
    //       this.restrict_stolenFees.has_fee == "false"
    //     ) {
    //       this.changeCardStatus();
    //     } else if (
    //       this.restrict_stolenFees != null &&
    //       this.restrict_stolenFees.has_fee == "true"
    //     ) {
    //       this.stopCardDialog(
    //         this.restrict_stolenFees.fee,
    //         this.restrict_stolenFees.currency
    //       );
    //     }
    //   } else if (this.stopCardObject.status == "lost") {
    //     if (
    //       this.restrict_lostFees != null &&
    //       this.restrict_lostFees.has_fee == "false"
    //     ) {
    //       this.changeCardStatus();
    //     } else if (
    //       this.restrict_lostFees != null &&
    //       this.restrict_lostFees.has_fee == "true"
    //     ) {
    //       this.stopCardDialog(
    //         this.restrict_lostFees.fee,
    //         this.restrict_lostFees.currency
    //       );
    //     }
    //   } else {
    //     this.changeCardStatus();
    //   }
    // },
    changeCardStatusDialog(card, status, string) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + string,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () => this.changeCardStatus(card, status),
      });
    },
    changeCardStatus(card, status) {
      axios
        .post("/vs/card/status/change", { card_uuid: card.card_uid, status })
        .then((response) => {
          // eslint-disable-next-line no-empty
          if (response.data.status === "success") {
            card.card_status = status === "open" ? "مفعلة" : "موقوفة";
            console.log(this.customerCards);
            this.stopCardModal = false;
            this.stopCardObject.card_uid = null;
            this.stopCardObject.status = null;
            // this.getCustomerCards();
            this.newCardMsgModal(response.data.message);
          } else if (response.data.status === "fail") {
            console.log("error");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toasted.show(`${error.response.data.message}`, {
            theme: "outline",
            position: "top-center",
            duration: 3000,
            type: "error",
            theme: "bubble",
            className: "toasti",
            iconPack: "fontawesome",
            closeOnSwipe: true,
            icon: {
              name: "fa-times",
              before: true, // this will append the icon to the end of content
            },
          });
        });
    },
    newCardMsgModal(msg) {
      this.$dialog.confirm({
        message: msg,
        cancelText: "إغلاق",
        confirmText: "موافق",
        type: "is-success",
      });
    },
    resetPinMsgModal(msg) {
      this.$dialog.confirm({
        message: msg,
        cancelText: "إغلاق",
        confirmText: "موافق",
        type: "is-success",
      });
    },
    newCardFeeDialog(fee, currency) {
      this.$dialog.confirm({
        message: " يوجد عمولة بقيمة " + fee + " " + currency,
        cancelText: "إغلاق",
        confirmText: "موافق",
        type: "is-warning",
        onConfirm: () => this.getNewCardRequest(),
      });
    },
    getCardStatmentDialog(fee, currency, card_uid) {
      this.$dialog.confirm({
        message: " يوجد عمولة بقيمة " + fee + " " + currency,
        cancelText: "إغلاق",
        confirmText: "موافق",
        type: "is-warning",
        onConfirm: () => this.getCardStatment(card_uid),
      });
    },
    resetPinDialog(fee, currency, card_uid) {
      this.$dialog.confirm({
        message: " يوجد عمولة بقيمة " + fee + " " + currency,
        cancelText: "إغلاق",
        confirmText: "موافق",
        type: "is-warning",
        onConfirm: () => this.resetCardModalOpen(card_uid),
      });
    },
    // stopCardDialog(fee, currency) {
    //   this.$dialog.confirm({
    //     message: " يوجد عمولة بقيمة " + fee + " " + currency,
    //     cancelText: "إغلاق",
    //     confirmText: "موافق",
    //     type: "is-warning",
    //     onConfirm: () => this.changeCardStatus(),
    //   });
    // },
  },
  mounted() {
    //this.getCustomerCards();
  },
  created() {
    this.cardsAreLoading = true;
    this.getCustomerCards();

    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        cardId: "الرقم التعريفي للبطاقة",
        cardNumber: "رقم البطاقة",
        status: "حالة البطاقة",
      },
    });
  },
};
</script>
